import { DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTariffRegionQuickInfo extends Layout {
    panelTariffRegionQuickInfo: Panel;
    sourceTariffRegion: DataSource;
    textboxRegionName: Textbox;
    textboxRegionNickname: Textbox;
}
